import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAMDeUBkj_Z3v-n6RKsrdVGZNQ9oSx2mqk",
  authDomain: "call-tracker-bec25.firebaseapp.com",
  projectId: "call-tracker-bec25",
  storageBucket: "call-tracker-bec25.firebasestorage.app",
  messagingSenderId: "175316877672",
  appId: "1:175316877672:web:093c270f446e1a471616dd",
  measurementId: "G-QPTSPNWV4M"
};

const app = initializeApp(firebaseConfig);

// Initialize Analytics only in environments that support it (not SSR/Node)
let _analytics = null;
isSupported().then(yes => { if (yes) _analytics = getAnalytics(app); });

export const db             = getFirestore(app);
export const auth           = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Thin wrapper — safe to call even if Analytics isn't supported
export function track(eventName, params) {
  if (_analytics) {
    import("firebase/analytics").then(({ logEvent }) => {
      logEvent(_analytics, eventName, params || {});
    }).catch(() => {});
  }
}
